import moment from 'moment';
import { dateFormatInput } from './const.js';

// eslint-disable-next-line import/prefer-default-export
export const formatDate = (dateString, dateFormat = dateFormatInput) => {
  const date = new Date(dateString);
  return moment(date).format(dateFormat);
};
